class RhiTabs extends HTMLElement {
  connectedCallback() {
    this.#links = [...this.querySelectorAll('[data-rhi-link]')];
    this.#contentSectionId = this.dataset.contentSectionId || 'rhi_content';

    this.#links.forEach(link => {
      link.addEventListener('click', (e) => this.#handleNavigation(e, link));
    });
  }

  #links = [];
  #contentSectionId = '';

  async #handleNavigation(e, link) {
    const url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin) return;

    e.preventDefault();
    
    const targetUrl = link.href;
    if (targetUrl === window.location.href) return;

    // Loading state for the navigation
    this.classList.add('is-loading');

    // Find the content section in the DOM
    const contentSectionElement = document.getElementById(`shopify-section-${this.#contentSectionId}`);
    if (contentSectionElement) {
      contentSectionElement.style.opacity = '0.5';
      contentSectionElement.style.pointerEvents = 'none';
    }

    try {
      // Fetch the content section from the target page
      const fetchUrl = `${targetUrl}${targetUrl.includes('?') ? '&' : '?'}section_id=${this.#contentSectionId}`;
      const response = await fetch(fetchUrl);
      const html = await response.text();
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Shopify returns the section wrapped in a div with class 'shopify-section'
      const newSectionContent = doc.querySelector('.shopify-section');
      
      if (newSectionContent && contentSectionElement) {
        contentSectionElement.innerHTML = newSectionContent.innerHTML;
        contentSectionElement.className = newSectionContent.className;
        contentSectionElement.style.opacity = '1';
        contentSectionElement.style.pointerEvents = 'auto';

        // Update active tab state
        this.#links.forEach(l => {
          const isActive = l.href === targetUrl;
          l.setAttribute('aria-selected', isActive ? 'true' : 'false');
          l.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        // Update URL and Title
        history.pushState({}, '', targetUrl);
        const newTitle = doc.querySelector('title');
        if (newTitle) document.title = newTitle.textContent;

        // Scroll to top of content
        window.scrollTo({
          top: this.offsetTop - 20,
          behavior: 'smooth'
        });
      } else {
        // Fallback
        window.location.href = targetUrl;
      }
    } catch (err) {
      console.error('Section Rendering API error:', err);
      window.location.href = targetUrl;
    } finally {
      this.classList.remove('is-loading');
    }
  }
}

if (!customElements.get('rhi-tabs')) {
  customElements.define('rhi-tabs', RhiTabs);
}

// Handle back/forward buttons
window.addEventListener('popstate', () => {
  window.location.reload();
});
